import React from "react";

interface FilterBarProps {
    search: string;
    setSearch: (v: string) => void;
    groupFilter: string;
    setGroupFilter: (v: string) => void;
    stateFilter: string;
    setStateFilter: (v: string) => void;
    groupOptions: string[];
    stateOptions: string[];
    hasActiveFilters: boolean;
    handleClearFilters: () => void;
}

export const FilterBar: React.FC<FilterBarProps> = ({
    search,
    setSearch,
    groupFilter,
    setGroupFilter,
    stateFilter,
    setStateFilter,
    groupOptions,
    stateOptions,
    hasActiveFilters,
    handleClearFilters,
}) => {
    return (
        <div style={{ background: "#fff", border: "1px solid #e5e7eb", borderRadius: "12px", padding: "16px 18px", marginBottom: "16px", display: "flex", alignItems: "center", gap: "12px", flexWrap: "wrap" }}>
            <div style={{ display: "flex", alignItems: "center", gap: "10px", flex: 1, minWidth: "280px", background: "#f8fafc", border: "1px solid #e2e8f0", borderRadius: "9px", padding: "2px 8px 2px 12px" }}>
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#94a3b8" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <circle cx="11" cy="11" r="8"></circle>
                    <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
                </svg>
                <input
                    type="text"
                    placeholder="Buscar por código CNX, razão social, nome fantasia, CNPJ ou cidade..."
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                    style={{ flex: 1, border: "none", fontSize: "13.5px", padding: "9px 0", background: "transparent", color: "#1f2933", outline: "none" }}
                />
                {search && (
                    <button
                        onClick={() => setSearch("")}
                        style={{ background: "none", border: "none", color: "#94a3b8", cursor: "pointer", padding: "4px", display: "flex", alignItems: "center", borderRadius: "4px" }}
                        title="Limpar busca"
                    >
                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                            <line x1="18" y1="6" x2="6" y2="18"></line>
                            <line x1="6" y1="6" x2="18" y2="18"></line>
                        </svg>
                    </button>
                )}
            </div>

            <select
                value={groupFilter}
                onChange={(e) => setGroupFilter(e.target.value)}
                style={{ padding: "9px 12px", border: "1px solid #e2e8f0", borderRadius: "9px", fontSize: "13px", color: "#1f2933", background: "#fff", cursor: "pointer" }}
            >
                <option value="">Todos os grupos</option>
                {groupOptions.map((g) => (
                    <option key={g} value={g}>
                        {g}
                    </option>
                ))}
            </select>

            <select
                value={stateFilter}
                onChange={(e) => setStateFilter(e.target.value)}
                style={{ padding: "9px 12px", border: "1px solid #e2e8f0", borderRadius: "9px", fontSize: "13px", color: "#1f2933", background: "#fff", cursor: "pointer" }}
            >
                <option value="">Todos os estados</option>
                {stateOptions.map((uf) => (
                    <option key={uf} value={uf}>
                        {uf}
                    </option>
                ))}
            </select>

            {hasActiveFilters && (
                <button
                    onClick={handleClearFilters}
                    style={{
                        display: "inline-flex",
                        alignItems: "center",
                        gap: "6px",
                        padding: "9px 14px",
                        border: "1px solid #fed7aa",
                        borderRadius: "9px",
                        fontSize: "13px",
                        fontWeight: 600,
                        color: "#c2410c",
                        background: "#fff7ed",
                        cursor: "pointer",
                        transition: "all 0.15s",
                    }}
                    title="Limpar todos os filtros aplicados"
                >
                    <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                        <line x1="18" y1="6" x2="6" y2="18"></line>
                        <line x1="6" y1="6" x2="18" y2="18"></line>
                    </svg>
                    Limpar filtros
                </button>
            )}
        </div>
    );
};
